import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import moment from "moment";

const LogsTable = ({ data }) => {
  const columns = [
    { field: "id", type: "number", headerName: "ID", width: 80 },
    { field: "method_request", headerName: "Metodo", width: 100 },
    { field: "access_token", headerName: "Token", width: 300 },
    {
      field: "datetime_request",
      headerName: "Datetime",
      width: 200,
      renderCell: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY HH:mm:ss") : "",
    },
    { field: "path_request", headerName: "Request", width: 200 },
    { field: "ip", headerName: "IP", width: 120 },
  ];

  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <Box>
        <DataGrid
          rows={data}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 100 },
            },
          }}
          pageSizeOptions={[100]}
          scrollbarSize={10}
          autoHeight
        />
      </Box>
    </Box>
  );
};

export default LogsTable;
